import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { FormControl } from '@mui/material';

import BaseAutocomplete from '../../../../../../../shared/components/base-autocomplete/base-autocomplete';
import BaseRenderInput from '../../../../../../../shared/components/base-autocomplete/components/base-render-input/base-render-input';
import { useAppDispatch } from '../../../../../../../store/hooks';
import { filterReviewsByVehicle } from '../../../store/slices/slices/reviews.slice';
import { useGetReviewFilters } from '../hooks/use-get-review-filters/use-get-review-filters.hook';
import { AllReviewsFiltersProps } from '../types/all-reviews-filters-props';
import withFilterValues from './with-filter-values';

const VehiclesDropdown: FunctionComponent<AllReviewsFiltersProps> = (
  props: PropsWithChildren<AllReviewsFiltersProps>
): ReactElement => {
  const { vehicles } = useGetReviewFilters();
  const dispatch = useAppDispatch();

  const { setFieldValue, filterValues } = props;

  return (
    <FormControl
      data-testid="vehicles-dropdown"
      key="vehicle-filter"
      classes={{
        root: 'form-control-main',
      }}
    >
      <BaseAutocomplete
        id="vehicle"
        freeSolo={false}
        multiple={false}
        options={vehicles}
        value={filterValues?.vehicle || null}
        onChange={(event, value) => {
          setFieldValue('vehicle', value);
          dispatch(filterReviewsByVehicle(value ?? ''));
        }}
        renderInput={params => (
          <BaseRenderInput
            {...params}
            id="vehicle"
            label="Vehicle"
            name="vehicle"
            errors={props.errors}
            touched={props.touched}
          />
        )}
      />
    </FormControl>
  );
};

export default withFilterValues(VehiclesDropdown);
